module.exports = __webpack_public_path__ + "assets/img/carousel-1-320.3335674b.webp";